import React from 'react'
import { Section } from './Page.styles'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'
import CompassHealing from './CompassHealing'
import BioImage1 from './Images/BioImage1'
import BioImage2 from './Images/BioImage2'
import BioImage3 from './Images/BioImage3'
import BioImage4 from './Images/BioImage4'

const SecondSection = styled(Section)`
    flex-direction: column;
    padding-top: 8rem;
    justify-content: center;
    
    @media (min-width: 1180px) {
        flex-direction: row;
    }
`

const SectionTitle = styled.h2`
    color: #000;
    width: 100%;
	font-size: 28px;
	margin-bottom: 2rem;    
	font-weight: 800;
`

const Paragraph = styled.p`
	font-size: 18px;
	width: 100%;
	line-height: 1.4;
	margin-bottom: 2rem;
`

const Stat = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	margin: 0 1rem;
	
	@media (min-width: 768px) {
	    margin: 0 2rem;
	}
`;

const StatTitle = styled.div`
	font-size: 32px;
	font-weight: 500;
	font-family: "Montserrat", sans-serif;
	margin-bottom: 1rem;
	color: #5aa8ff;
	
	@media (min-width: 768px) {
	    font-size: 48px;
	}
`;

const StatValue = styled.div`
	font-weight: 500;
`;

const Column = styled.div`
    max-width: 90%;
    margin: 0 auto;

    @media (min-width: 800px) {
        max-width: 60%;
    }

    @media (min-width: 1180px) {
        margin: 0;
    	flex: 0 0 500px;
    }
`;

const ImageWrapper = styled.div`
	width: ${props => props.width}px;
	margin: 0 auto 2rem;
	max-width: 90%;
	
	@media (min-width: 1180px) {
	    margin-right: 0;
        margin-left: auto;
	}
`;

const SvgWrapper = styled.div`
    width: 200px;
    margin: 0 auto 2rem;
`

const Highlight = styled.div`
	background: #f7f6fb;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2rem;
	margin-bottom: 2rem;
`;

const FirstColumn = styled(Column)`
    order: 2;
    
    @media (min-width: 1180px) {
        order: 1;
    	margin-right: 3rem;
    }
`;

const SecondColumn = styled(Column)`
    order: 1;
    
    @media (min-width: 1180px) {
        order: 2;
    }
`;

const Bio = () => {
    return (
        <SecondSection>
            <FirstColumn>
                <Fade duration={500} cascade up>
                <ImageWrapper width={500}>
                    <BioImage1 />
                </ImageWrapper>
                <ImageWrapper width={500}>
                    <BioImage2 />
                </ImageWrapper>
                <ImageWrapper width={500}>
                    <BioImage3 />
                </ImageWrapper>
                <ImageWrapper width={500}>
                    <BioImage4 />
                </ImageWrapper>
                </Fade>
            </FirstColumn>
            <SecondColumn>
                <Fade duration={500} cascade up>
                    <SectionTitle>Who is Emanuel?</SectionTitle>
                    <Paragraph>
                        Emanuel grew up in a household with parents in the medical field profession as Oncologists and Hematologists. His mother was an inspiration and best friend. Dr. Maria Guerra opened his eyes to chakras, energy healing, and different methods of healing due to her dedication to her patients. Emanuel’s mother had knowledge in alternative medicine and this heavily influenced him at a young age and ultimately led to his future career as an Emotion Code and Body Code practitioner. Combined with his Christian faith, he found a deep, loving resonance for energy healing and developed a burning passion to relieve emotional and physical symptoms in people.
                    </Paragraph>
                    <Paragraph>
                        Prior to his energy healing work, Emanuel worked in the direct sales industry and gained international business experience as a bilingual speaker and sales trainer. Despite his talent, his success was minimal, and he lacked fulfillment in his life. He noticed a high turnover rate within the company he worked for. Knowing it was not his true calling in life, he began a journey to find his true purpose. He began to seek  answers to deeper questions. He wondered “Why do couples separate after 30 years? Why is it that every time I pursue a new goal, I feel like there is something blocking me?”
                    </Paragraph>
                    <Paragraph>
                        Two months into his quest, the Emotion Code came into his life, and he realized why people quit on themselves, why marriages fail, and why people deal with disease and emotional ailments. While undergoing his Emotion Code, and later Body Code, certification, he found joy in releasing trapped emotions in people and witnessing them find their God-given mission. The Emotion Code could have saved his mother from pancreatic cancer, and she would have given more value to society if her life hadn’t ended so abruptly. There are millions of people that would have given more to this earth if they had only been granted the knowledge of emotional anchors that subconsciously took days away from their lives. The Emotion and Body Code is the most advanced healing system that can assist someone from a distance or in person. <strong>For more information on the Emotion and Body Code, refer to the videos below.</strong>
                    </Paragraph>
                    <SvgWrapper>
                        <CompassHealing />
                    </SvgWrapper>
                    <Paragraph>
                        In November 2016, Coding Alternative LLC was born. Since the beginning of his practice, he always gives credit to his Father in Heaven for this miraculous modality of healing discovered by Dr. Bradley Nelson. In less than a year and a half, Coding Alternative obtained the highest count of five-star ratings of any practice in the world. Over 4,000 clients had their hearts opened and lives changed through his mission: to serve people through energy healing. He recently founded Compass Healing Center in 2019 and his practice still continues to meet with 80 clients a week and remains the highest five-star reviewed practice in the world. He is fortunate enough to work with his wife and soulmate, Jessica Zevallos, who assists with administrative work as an assistant, and an Emotion and Body Code Practitioner in Compass Healing Center. He is now transitioning to have more practitioners working at Compass Healing as he focuses on his new endeavor, the Inside Out Institute.
                    </Paragraph>
                    <Highlight>
                        <Stat>
                            <Fade duration={500} up cascade>
                                <StatTitle>4000+</StatTitle>
                                <StatValue>Clients Served</StatValue>
                            </Fade>
                        </Stat>
                        <Stat>
                            <Fade duration={500} up cascade>
                                <StatTitle>700+</StatTitle>
                                <StatValue>5-star Reviews</StatValue>
                            </Fade>
                        </Stat>
                    </Highlight>
                    <Paragraph>
                        Emanuel loves to give back. While attending Army and Navy Academy as a teenager in Carlsbad, California, he was mentored by veterans and gained true respect for the military. He learned that many of them deal with PTSD symptoms. This led him to start a Veteran PTSD program where he volunteered hours of free sessions to clear their “Heart-Wall" and assist in the healing of their traumas. With a goal of assisting two Veterans a month, he has treated dozens of Veterans since 2016 with staggering results. All Veteran clients reported having lost almost all symptoms of PTSD, depression, and any signs of anxiety.
                    </Paragraph>
                    <Paragraph>
                        He works with all types of people: successful business owners, stay at home mothers, celebrities, and people who are interested in releasing their emotional and physical “baggage.” Emanuel is happily married to Jessica Zevallos and they live in Layton, Utah with their two children.
                    </Paragraph>
                </Fade>
            </SecondColumn>
        </SecondSection>
    )
}

export default Bio
